import { Box, Paper, Typography } from "@mui/material";
import mime from "mime";
import { useCallback, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { FiBookOpen, FiClipboard, FiClock, FiFile, FiMapPin } from "react-icons/fi";
import FileUpload from "../../../components/input/FileUpload";
import ImageUpload from "../../../components/input/ImageUpload";
import ResizableTextBox from "../../../components/input/ResizableTextBox";
import SelectBox from "../../../components/input/SelectBox";
import TextBox from "../../../components/input/TextBox";
import { useContextProvider } from "../../../components/page-context/ContextProvider";
import { TableHeaderContainer } from "../../../components/container/TableHeaderContainer";
import { TableTitleContainer } from "../../../components/container/TableTitleContainer";
// import { uniformat_II } from "../../../components/Uniformat_II";
import { ReusedProduct } from "../../../db_access/reused_product";
import muiSytle from "../../../style/components-style/muiStyle";
const ReusedProductProductInfo = ({ reusedProduct }) => {
  const { t } = useTranslation();
  const { isSaveClicked, setIsSaveVisible, setIsSaveClicked, setIsLoading } = useContextProvider();
  const { setRefresh } = useContextProvider();
  const [formData, setFormData] = useState({});
  const [photo, setPhoto] = useState();
  const [photoPreview, setPhotoPreview] = useState();

  const [specDocument, setSpecDocument] = useState();
  const [specDocumentPreview, setSpecDocumentPreview] = useState();

  const [safetyDocument, setSafetyDocument] = useState();
  const [safetyDocumentPreview, setSafetyDocumentPreview] = useState();

  const [modified, setModified] = useState(false);
  const ref = useRef(null);

  const getPhoto = useCallback(() => {
    if (reusedProduct && reusedProduct.id) {
      ReusedProduct.getPhoto(reusedProduct.id)
        .then((res) => {
          if (res.ok) {
            return res.blob();
          } else {
            return undefined;
          }
        })
        .then((j) => {
          setPhoto(j);
        });
    } else {
      setPhoto(undefined);
    }
  }, [reusedProduct]);
  const getSpecDocument = useCallback(() => {
    if (reusedProduct && reusedProduct.id) {
      ReusedProduct.getSpecDocument(reusedProduct.id)
        .then((res) => {
          if (res.ok) {
            return res.blob();
          } else {
            return undefined;
          }
        })
        .then((j) => {
          setSpecDocument(j);
        });
    } else {
      setSpecDocument(undefined);
    }
  }, [reusedProduct]);
  const getSafetyDocument = useCallback(() => {
    if (reusedProduct && reusedProduct.id) {
      ReusedProduct.getSafetyDocument(reusedProduct.id)
        .then((res) => {
          if (res.ok) {
            return res.blob();
          } else {
            return undefined;
          }
        })
        .then((j) => {
          setSafetyDocument(j);
        });
    } else {
      setSafetyDocument(undefined);
    }
  }, [reusedProduct]);

  useEffect(() => {
    const cleanData = {};
    if (reusedProduct) {
      Object.keys(reusedProduct).forEach((k) => {
        cleanData[k] = (reusedProduct[k] === null || reusedProduct[k] === "null") ? "" : reusedProduct[k];
      });
    }
    setFormData(cleanData);
    getPhoto();
    getSpecDocument();
    getSafetyDocument();
    setModified(false);
  }, [reusedProduct, getPhoto, getSpecDocument, getSafetyDocument]);

  const handleChange = (field) => (e) => {
    if (formData.isEpd) return;
    const value = e.target.value;
    setFormData({ ...formData, [field]: value });
    setIsSaveVisible(true);
    setModified(true);
  };
  // const handleSelectBoxChange = (field) => (e, newValue) => {
  //   setFormData({ ...formData, [field]: newValue ? newValue.value : null });
  //   setIsSaveVisible(true);
  //   setModified(true);
  // };

  const handlePhotoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setPhoto(file);
    } else {
      setPhoto(undefined);
    }
    setIsSaveVisible(true);
    setModified(true);
  };

  const handleSpecDocumentChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSpecDocument(file);
    } else {
      setSpecDocument(undefined);
    }
    setIsSaveVisible(true);
    setModified(true);
  };

  const handleSafetyDocumentChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSafetyDocument(file);
    } else {
      setSafetyDocument(undefined);
    }
    setIsSaveVisible(true);
    setModified(true);
  };
  const reset = async () => {
    if (formData && formData.id) {
      const resetProductInfo = ReusedProduct.resetProductInfo(formData.id);
      const resetPhoto = ReusedProduct.resetPhoto(formData.id);
      const resetSpecDocument = ReusedProduct.resetSpecDocument(formData.id);
      const resetSafetyDocument = ReusedProduct.resetSafetyDocument(formData.id);
      await Promise.all([resetProductInfo, resetPhoto, resetSpecDocument, resetSafetyDocument]).finally(() => {
        setModified(false);
        setIsSaveVisible(false);
        setRefresh((r) => !r);
      });
    }
  };
  useEffect(() => {
    if (photo) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPhotoPreview(reader.result);
      };
      reader.readAsDataURL(photo);
    } else {
      setPhotoPreview(undefined);
    }
  }, [photo]);
  useEffect(() => {
    if (specDocument) {
      setSpecDocumentPreview("spec_document." + mime.getExtension(specDocument.type));
    } else {
      setSpecDocumentPreview(undefined);
    }
  }, [specDocument]);
  useEffect(() => {
    if (safetyDocument) {
      setSafetyDocumentPreview("safety_document." + mime.getExtension(safetyDocument.type));
    } else {
      setSafetyDocumentPreview(undefined);
    }
  }, [safetyDocument]);

  useEffect(() => {
    if (isSaveClicked && modified) {
      const fd = new FormData();
      Object.keys(formData).forEach((k) => {
        fd.append(k, formData[k]);
      });
      fd.append("id", reusedProduct?.id);
      fd.append("photo", photo);
      fd.append("specDocument", specDocument);
      fd.append("safetyDocument", safetyDocument);
      ReusedProduct.updateProductInfo(fd)
        .catch((err) => {
          console.error("Error:", err);
        })
        .finally((_) => {
          setModified(false);
          setIsSaveClicked(false);
          setIsLoading(false);
          setRefresh((r) => !r);
        });
    }
  }, [isSaveClicked, modified, formData, photo, specDocument, safetyDocument, reusedProduct, setIsSaveClicked, setIsLoading, setRefresh]);

  useEffect(() => console.log(formData), [formData]);

  return (
    <Paper variant="Table Container">
      <TableHeaderContainer>
        <TableTitleContainer>
          <Typography variant="Table Title">{t("Product Info")}</Typography>
        </TableTitleContainer>
      </TableHeaderContainer>
      <Box sx={{ p: 3 }}>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }} ref={ref}>
          <Box sx={{ display: "flex", gap: 1 }}>
            <Box sx={{ flex: 2 }}>
              <ResizableTextBox
                Icon={FiBookOpen}
                label={"Reused Product Introduction"}
                placeholder={"Brief introduction"}
                value={formData.intro}
                onChange={handleChange("intro")}
                disabled={formData.isEpd}
              />
            </Box>
            <Box sx={{ display: "flex", flexDirection: "column", flex: 1, maxWidth: 400, maxHeight: 400 }}>
              <ImageUpload
                Icon={FiFile}
                label={"Reused Product Photo"}
                placeholder={"Click to upload photo"}
                onChange={handlePhotoChange}
                disabled={formData.isEpd}
                preview={photoPreview}
                alt={"Reused Product"}
                accept={"image/*"}
                deletePreview={() => {
                  setPhoto(undefined);
                  setIsSaveVisible(true);
                  setModified(true);
                }}
              />
            </Box>
          </Box>
          <Box sx={{ display: "flex", gap: 1 }}>
            <Box sx={{ flex: 2 }}>
              <ResizableTextBox
                Icon={FiClipboard}
                label={"Specifications"}
                placeholder={"Enter specifications"}
                value={formData.specifications}
                onChange={handleChange("specifications")}
                disabled={formData.isEpd}
              />
            </Box>
            <Box sx={{ display: "flex", flexDirection: "column", flex: 1, maxWidth: 400 }}>
              <FileUpload
                Icon={FiFile}
                label={"Specification Document"}
                preview={specDocumentPreview}
                placeholder={"Click to upload document"}
                onChange={handleSpecDocumentChange}
                disabled={formData.isEpd}
                accept={".pdf,.doc,.docx"}
                deletePreview={() => {
                  setSpecDocument(undefined);
                  setIsSaveVisible(true);
                  setModified(true);
                }}
                file={specDocument}
              />
            </Box>
          </Box>
          <Box sx={{ display: "flex", gap: 1 }}>
            <Box sx={{ display: "flex", gap: 1, flexDirection: "column", flex: 2 }}>
              <Box sx={{ flex: 1 }}>
                <TextBox
                  Icon={FiClipboard}
                  label={"Reused Product UUID"}
                  placeholder={"Product UUID"}
                  value={formData.uuid}
                  onChange={handleChange("uuid")}
                  disabled={formData.isEpd}
                />
              </Box>
              <Box sx={{ flex: 1 }}>
                <TextBox
                  Icon={FiClock}
                  label={"Service Life (years)"}
                  placeholder={"Years"}
                  value={formData.service_life}
                  onChange={handleChange("service_life")}
                  disabled={formData.isEpd}
                />
              </Box>
              <Box sx={{ flex: 1 }}>
                <TextBox
                  Icon={FiClock}
                  label={"Extended Service Life (years)"}
                  placeholder={"Years"}
                  value={formData.extended_service_life}
                  onChange={handleChange("extended_service_life")}
                  disabled={formData.isEpd}
                />
              </Box>
            </Box>
            <Box sx={{ display: "flex", flexDirection: "column", flex: 1, maxWidth: 400 }}>
              <FileUpload
                Icon={FiFile}
                label={"Product Safety"}
                preview={safetyDocumentPreview}
                placeholder={"Click to upload document"}
                onChange={handleSafetyDocumentChange}
                disabled={formData.isEpd}
                accept={".pdf,.doc,.docx"}
                deletePreview={() => {
                  setSafetyDocument(undefined);
                  setIsSaveVisible(true);
                  setModified(true);
                }}
                file={safetyDocument}
              />
            </Box>
          </Box>
          <Box sx={{ display: "flex", gap: 1 }}>
            <Box sx={{ flex: 1 }}>
              <TextBox
                Icon={FiMapPin}
                label={"Place of Manufacture"}
                placeholder="Place of Manufacture"
                value={formData.place_of_manufacture}
                onChange={handleChange("place_of_manufacture")}
                disabled={formData.isEpd}
              />
            </Box>
            <Box sx={{ flex: 1 }}>
              <TextBox
                Icon={FiMapPin}
                label={"Place of Use"}
                placeholder="Place of Use"
                value={formData.place_of_use}
                onChange={handleChange("place_of_use")}
                disabled={formData.isEpd}
              />
            </Box>
          </Box>
          {/* UNIFORMAT II Level 1 & 2 hidden for now
          <Box sx={{ display: "flex", gap: 1 }}>
            <Box sx={{ flex: 1 }}>
              <SelectBox
                Icon={FiMapPin}
                label={"UNIFORMAT II Level 1"}
                placeholder="UNIFORMAT II Level 1"
                value={formData.uniformat_II_1 || null}
                options={uniformat_II}
                onChange={handleSelectBoxChange("uniformat_II_1")}
                disabled={formData.isEpd}
              />
            </Box>
            <Box sx={{ flex: 1 }}>
              <SelectBox
                Icon={FiMapPin}
                label={"UNIFORMAT II Level 2"}
                placeholder="UNIFORMAT II Level 2"
                value={formData.uniformat_II_2 || null}
                options={uniformat_II.find((u) => u.value === formData.uniformat_II_1)?.subLevels || []}
                onChange={handleSelectBoxChange("uniformat_II_2")}
                disabled={formData.isEpd}
              />
            </Box>
          </Box>
          */}
        </Box>
      </Box>
    </Paper>
  );
};

export default ReusedProductProductInfo;
